import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SideBar from "../../shared/SideBar/SideBar";
import Loader from "../../shared/Loader/Loader";
import SAA_JSON from "./FeatureCourse/ModifiedSI.json";
import { Course, Category, Item, MenuData } from "./utils/types";

const StressAndIntonationSideBar = () => {
  const { activityId, templateID } = useParams();
  const [loader, setLoader] = useState(true);
  const [menus, setMenus] = useState<MenuData[]>([]);
  const [heading, setHeading] = useState("");

  useEffect(() => {
    if (activityId) {
      const course = SAA_JSON.find((item: Course) => item.Id === parseInt(activityId)) as Course;
      if (course) {
        const menuData = course.Categories.map((category: Category) => {
          const submenu = category.Items.map((item: Item) => {
            return {
              id: item.ActivityId,
              name: item.ActivityName,
              link: item.link,
              submenu: item,
            };
          });
          return {
            id: category.CategoryObjectId,
            name: category.CategoryName,
            subMenus: submenu,
          };
        });
        setHeading(course.Name);
        setMenus(menuData);
        setLoader(false);
      }
    }
  }, [templateID]);

  return (
    <div>
      {loader && <Loader showLoader={loader} />}
      <SideBar heading={heading} menus={menus} />
    </div>
  );
};

export default StressAndIntonationSideBar;
